import React from 'react';
import { styled } from '@glitz/react';
import Overlay from 'Shared/Overlay';
import { Close16x16 } from 'Shared/Icons/Close';
import { H2, ResponsiveSize } from 'Shared/SharedComponents/atoms/Typography';
import ErrorBoundary from 'Shared/ErrorBoundary';

const MenuHeaderText = styled(H2, {
  fontWeight: 'normal',
  display: 'inline-block',
  textAlign: 'center',
  width: '100%',
  margin: {xy : 0},
  marginTop: '20px',
});

const Header = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  minWidth: '100%',
  minHeight: '69px',
});

const CloseIcon = styled(Close16x16, {
  display: 'flex',
  position: 'absolute',
  cursor: 'pointer',
  right: '16px',
  top: '16px',
});

const Base = styled.div({
  display: 'flex',
  flexDirection: 'column',
  position: 'fixed',
  overflow: 'hidden',
  width: '100%',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: 'auto',
  marginBottom: 'auto',
  justifyContent: 'center',

});

const Content = styled.div({
  boxShadow: `0 2px 4px 0 rgba(0, 0, 0, .1), 0 2px 8px 0 rgba(0, 0, 0, .05)`,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
  overflow: 'hidden',
  position: 'relative',
});

const Body = styled.div({
  flexGrow: 1,
  height: 'inherit',
  position: 'relative',
  paddingLeft: '48px',
  paddingRight: '48px',
  paddingBottom: '32px',
});

type PropType = {
  header?: string;
  isOpen: boolean;
  canOpen: boolean;
  maxWidth: string;
  maxHeight: string;
  toggleModal: (e?: React.SyntheticEvent<{}>) => void;
  allowOverflow: boolean;
};

export default class Modal extends React.Component<PropType> {
  base: HTMLDivElement;
  render() {
    const { isOpen, toggleModal, header, maxWidth, maxHeight, allowOverflow } = this.props;

    return (
      <Overlay onClose={toggleModal} enabled={isOpen}>
        {isOpen && (
          <Base
            className="sg-popup"
            css={{
              maxWidth: maxWidth || '45rem',
              height: maxHeight && maxHeight === 'none' ? 'fit-content' : maxHeight ? maxHeight : '60rem',
              maxHeight: maxHeight || `calc(80% - 16px)`,
            }}
          >
            <Content>
              {header && (
                <Header>
                  <MenuHeaderText fontSize={ResponsiveSize.D24_M20}>{header}</MenuHeaderText>
                  <CloseIcon onClick={toggleModal} />
                </Header>
              )}
              <Body
                css={
                  allowOverflow
                    ? {
                      overflow: 'auto',
                    }
                    : {
                      // Using flexbox here helps us growing children to
                      // full height in some cases
                      display: 'flex',
                      flexDirection: 'column',
                    }
                }
              >
                <ErrorBoundary reloadCurrentPage>{this.props.children}</ErrorBoundary>
              </Body>
            </Content>

          </Base>
        )}
      </Overlay>
    );
  }
}
